module.exports = __webpack_public_path__ + "img/interaction-bar-with-search-v-luxury-cjdr.0be66929.png";